export enum ePropertyType {
  CONDO = 'CONDO',
  COOPERATIVE = 'COOPERATIVE',
  MANUFACTURED = 'MANUFACTURED',
  MULTI_FAMILY = 'MULTI_FAMILY',
  PUD = 'PUD',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
}

export const DisplayPropertyType = {
  [ePropertyType.CONDO]: 'Condo',
  [ePropertyType.COOPERATIVE]: 'Cooperative',
  [ePropertyType.MANUFACTURED]: 'Manufactured',
  [ePropertyType.MULTI_FAMILY]: 'Multi-Family',
  [ePropertyType.PUD]: 'PUD',
  [ePropertyType.SINGLE_FAMILY]: 'Single Family',
};
